module.exports = function UpdateSourceDeregistrationRequest(cid) {
    this.cid = cid;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-deregistration-request.js
// module id = 734
// module chunks = 1